import { render, staticRenderFns } from "./ColumnCarousel.vue?vue&type=template&id=e9797fba&scoped=true&lang=pug&"
import script from "./ColumnCarousel.vue?vue&type=script&lang=js&"
export * from "./ColumnCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ColumnCarousel.vue?vue&type=style&index=0&id=e9797fba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9797fba",
  null
  
)

export default component.exports